module.exports = __webpack_public_path__ + "img/estimateBoxPhoto.4f14c3b0.png";